import type { Ref } from "react";

function assignRef<T>(ref: Ref<T> | undefined, instance: T | null) {
  if (!ref) return;

  if (typeof ref === "function") {
    ref(instance);
  } else {
    ref.current = instance;
  }
}

export { assignRef };
